import { css } from 'styled-components';
import _ from 'lodash';
import { colorVariables, fontVariables, fontFamilyVariables } from 'theme/variables';

const base = css`
  position: relative;
  margin: 0;
  font-weight: inherit;
  user-select: none;
  transition: color 135ms ease-in;

  ${(props) => css`
    font-family: ${_.get(fontFamilyVariables, props.font, null) || fontFamilyVariables.din_regular};
    color: ${_.get(colorVariables, props.color, null) || colorVariables.gray_nightrider};
    font-size: ${_.get(fontVariables, props.size, null) || fontVariables.fs_xs};
    &:hover {
      color: ${_.get(colorVariables, props.hover, null)};
      transition: color 135ms ease-out;
    }
  `}

  ${(props) =>
    props.disable &&
    css`
      cursor: default;
      pointer-events: none;
    `}

  ${(props) =>
    props.type === 'interaction'
      ? css`
          cursor: pointer;
        `
      : css`
          text-transform: ${props.type};
        `}
`;

export default base;
